export enum DocumentRequirement {
    NONE = 'NONE',
    OPTIONAL = 'OPTIONAL',
    MANDATORY = 'MANDATORY',
}

export enum AccrualRule {
    NONE = 'NONE',
    PER_DAYS_WORKED = 'PER_DAYS_WORKED',
}

export interface LeaveTypeConfig {
    id: string;
    name: string;
    institutionId: string;
    documentRequirement: DocumentRequirement;
    isPaid?: boolean;
    isActive?: boolean;
    encashable?: boolean;
    // Spec §3 — accrual settings (Task 5's LeaveTypeDTO additions). accrualRule NONE means the
    // type keeps using its policy-based grant; PER_DAYS_WORKED replaces that grant with the
    // engine's accrued total (spec §2.4 path 2).
    accrualRule?: AccrualRule;
    accrualDaysPerUnit?: number;
    carryForwardCapDays?: number;
    // Maternity leave decision (2026-09-08) D1/D4/D6/D9. minimumTenureMonths null/undefined means
    // "no tenure gate"; attendanceBonusExempt excludes approved days of this type from the
    // attendance-bonus threshold test in payroll.
    minimumTenureMonths?: number | null;
    attendanceBonusExempt?: boolean;
}

export interface LeaveDocument {
    id: string;
    leaveApplicationId: string;
    originalFileName: string;
    contentType: string;
    fileSize: number;
}

export enum LeaveStatus {
    Pending = 'Pending',
    Approved = 'Approved',
    Rejected = 'Rejected',
    Cancelled = 'Cancelled'
}

export interface LeaveApplication {
    id: string;
    userId: string;
    userName: string | null;
    /** Applicant's profile name (else username). */
    userDisplayName?: string | null;
    leaveType: string;
    leaveReason: string;
    applicationDate: string;
    startDate: string;
    endDate: string;
    leaveStatus: LeaveStatus;
    documents: LeaveDocument[];
    numberOfDays: number;
    actionedByName: string | null;
    /** Approver's profile display name (falls back to username server-side). */
    actionedByDisplayName?: string | null;
    actionedAt: string | null;
}

export interface LeaveApplicationResponse {
    content: LeaveApplication[];
    totalElements: number;
    totalPages: number;
    size: number;
    number: number;
}

export interface LeavePolicy {
    id: string;
    institutionId: string;
    leaveType: string;
    numberOfLeaves: number;
    isActive?: boolean;
}

export interface LeavePolicyCreate {
    institutionId: string;
    leaveType: string;
    numberOfLeaves: number;
}

export interface UserLeaveAllocation {
    id: string;
    institutionId: string;
    userId: string;
    userName: string;
    userDisplayName?: string | null;
    leaveType: string;
    numberOfLeaves: number;
    fiscalYear: number;
    isOverride: boolean;
}

export interface UserLeaveAllocationCreate {
    institutionId: string;
    userId: string;
    leaveType: string;
    numberOfLeaves: number;
    fiscalYear: number;
}

export interface LeaveBalance {
    userId: string;
    userName: string;
    leaveType: string;
    allocated: number;
    availed: number;
    remaining: number;
    isOverride: boolean;
}

export interface UserLeaveBalanceSummary {
    userId: string;
    userName: string;
    userDisplayName?: string | null;
    balances: LeaveBalance[];
}
